import { motion } from "framer-motion";
import { Plane, Building2, MonitorPlay, Check } from "lucide-react";
import { CORE_BUSINESS } from "@/lib/site-data";

const ICONS = [Plane, Building2, MonitorPlay];

export default function CoreBusiness() {
  return (
    <section id="core" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl mb-14"
      >
        <span className="text-xs uppercase tracking-[0.3em] text-primary font-medium">
          What We Do
        </span>
        <h2 className="font-display text-4xl md:text-6xl text-secondary mt-4 leading-[1.02]">
          Core business areas.
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-5">
        {CORE_BUSINESS.map((c, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`core-${i}`}
              className="group rounded-2xl border border-border bg-card p-7 hover:-translate-y-1 hover:border-primary/50 transition-[transform,border-color] duration-400 hover:shadow-lg"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="h-11 w-11 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon size={20} className="text-primary" />
                </span>
                <span className="font-display text-4xl text-primary/15 font-medium">{c.no}</span>
              </div>
              <h3 className="font-display text-2xl text-secondary leading-snug min-h-[3.5rem]">
                {c.title}
              </h3>
              <ul className="mt-5 space-y-2.5">
                {c.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm text-foreground/75">
                    <Check size={15} className="text-primary mt-0.5 shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
